import React from 'react';
import PhotoViewer, { type ViewerPhoto } from '../photos/PhotoViewer';

type ViewerState = { photos: ViewerPhoto[]; index: number };

function withIndex(state: ViewerState | null, index: number): ViewerState | null {
  return state ? { ...state, index } : null;
}

/**
 * Opens a chat message's pictures in PhotoViewer, over the chat, instead of a new browser tab
 * (docs/chat-widget.md, "Pictures open in place"). Render `viewer` once beside the attachments.
 */
export function useAttachmentViewer() {
  const [state, setState] = React.useState<ViewerState | null>(null);
  const open = React.useCallback((photos: ViewerPhoto[], index: number) => {
    if (photos.length) setState({ photos, index: Math.max(0, Math.min(index, photos.length - 1)) });
  }, []);
  const viewer = state ? (
    <PhotoViewer
      photos={state.photos}
      index={state.index}
      onIndexChange={(index) => setState((current) => withIndex(current, index))}
      onClose={() => setState(null)}
    />
  ) : null;
  return { open, viewer };
}
